export interface SyncNotice {
  eventId?: number;
  providerName?: string;
  clientName?: string;
  startDate?: Date;
  endDate?: Date;
  downStream: string;
  CreatedBy?: string;
  totalCount?: number;
  failureCount?: number;
  status?: string;
  isSupressLink: boolean;
}

// True when a sync notice refers to Central Reach. Normalizes across the
// different forms the value can take (e.g. 'CENTRAL_REACH', 'Central Reach', 'CR').
export const isCentralReachDownStream = (downStream?: string) => {
  const normalized = (downStream ?? '').toUpperCase().replace(/[^A-Z]/g, '');
  return normalized.includes('CENTRALREACH') || normalized === 'CR';
};
